import { fromJS } from 'immutable';

import {
  LOAD_ONBOARDING_STATE,
  LOAD_ONBOARDING_STATE_SUCCESS,
  LOAD_ONBOARDING_STATE_ERROR,
} from './constants';

const initialState = fromJS({
  viewedOnboarding: {},
  loading: false,
  error: null,
});

function userOnboardingReducer(state = initialState, action) {
  switch (action.type) {
  case LOAD_ONBOARDING_STATE:
    return state
      .set('loading', true)
      .set('error', null)
      .set('viewedOnboarding', fromJS({}));
  case LOAD_ONBOARDING_STATE_SUCCESS:
    return state
      .set('viewedOnboarding', action.viewedOnboarding)
      .set('loading', false);
  case LOAD_ONBOARDING_STATE_ERROR:
    return state
      .set('error', action.error)
      .set('loading', false);
  default:
    return state;
  }
}

export default userOnboardingReducer;



/** WEBPACK FOOTER **
 ** ./src/containers/user-onboarding-state/reducer.js
 **/